module.exports = __webpack_public_path__ + "static/media/todayTractor.eed8db0c.svg";